<template>
  <span>
    <span @click.stop="open">
      <slot></slot>
    </span>
    <el-dialog append-to-body title="其它套餐" top="15vh" :visible="dialogVisible" width="300px" @close="close">
      <div class="dialog-wrap" style="padding-top: 10px;">
        <div class="my-flex my-p-t-10 my-row-center">
          <el-link type="primary" :underline="false" @click="$refs.loginDialog.open()">登录后</el-link>
          <span class="my-p-l-5">查看价格详情</span>
        </div>
        <contact-service></contact-service>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" size="mini">关闭</el-button>
      </div>
    </el-dialog>

    <login-dialog ref="loginDialog" @confirm="loginConfirm" />
  </span>
</template> 
  <script>
import loginDialog from '@/_myComponents/LoginDialog/index.vue'

export default {
  name: '',
  components: { loginDialog },
  props: {},
  data() {
    return {
      dialogVisible: false,
      type: 'login'
    }
  },
  computed: {},
  created() {},

  methods: {
    loginConfirm(userInfo) {
      this.dialogVisible = false
      this.$emit('confirm', userInfo)
    },
    close() {
      this.dialogVisible = false
    },
    confirm() {},
    open() {
      this.dialogVisible = true
    }
  }
}
</script>
            
<style lang="scss" >
</style>
            